import { Link } from 'react-router'

import { SmartImage } from './SmartImage'
import { paths } from '@/lib/paths'
import type { Artwork, Locale } from '@/lib/types'

interface ArtworkCardProps {
  artwork: Artwork
  locale: Locale
  /** The first row is above the fold and should not be lazy loaded. */
  priority?: boolean
}

export function ArtworkCard({ artwork, locale, priority = false }: ArtworkCardProps) {
  const year = artwork.createdOn ? new Date(artwork.createdOn).getFullYear() : null

  return (
    <article className="group">
      <Link to={paths.artwork(locale, artwork)} className="block">
        <div className="aspect-4/5 overflow-hidden rounded-[var(--radius-card)] bg-stone-100">
          <SmartImage
            media={artwork.cover}
            locale={locale}
            alt={artwork.title}
            priority={priority}
            preferred="card"
            className="h-full w-full transition-transform duration-700 ease-out group-hover:scale-[1.03]"
          />
        </div>

        <div className="mt-3 flex items-baseline justify-between gap-3">
          <h3 className="font-[family-name:var(--font-display)] text-lg leading-snug text-stone-900">
            {artwork.title}
          </h3>
          {year && (
            <time
              dateTime={artwork.createdOn}
              className="shrink-0 text-sm tabular-nums text-stone-400"
            >
              {year}
            </time>
          )}
        </div>
      </Link>
    </article>
  )
}
